<template>
<v-row>
  <v-col>
      <h4 class="text-right mb-1">
        {{ dataField.title ? dataField.title : "" }}
      </h4>
    <div style="height: 30vh;margin-bottom:2vh">
      <v-icon large style="position:absolute;z-index:9999;margin-top:11.9vh;margin-right:41%">mdi mdi-map-marker</v-icon>
      <l-map
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
      >
      
        <l-tile-layer
          :url="url"
          :attribution="attribution"
        />

      </l-map>
    </div>
  </v-col>
</v-row>

</template>


<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer} from "vue2-leaflet";import 'leaflet/dist/leaflet.css';
export default {
  name: "MapPickerBox",
  props: ["dataField"],
   components: {
    LMap,
    LTileLayer,
   
  },
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  mounted(){
    navigator.geolocation.getCurrentPosition(
      pos =>{
        this.currentCenter = this.center = latLng(pos.coords.latitude,pos.coords.longitude)
      }
    );
  },
 data() {
    return {
      zoom: 17,
      center: latLng(32.641915, 51.667054),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      currentZoom: 2,
      currentCenter: latLng(32.641915, 51.667054),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
    };
  },
  methods: {
    centerUpdate(center) {
      this.currentCenter = center;
      console.log("center is :",center);
      this.dataPost[this.dataField.name] = center;
    },
  }
};
</script>
<style >
</style>